/**
 * MYD Size Chart — custom bottom sheet + Kiwi as data source.
 * Public: window.MYDSizeChart.open(productLike), .close()
 */
(function () {
  if (window.__mydSizeChartBound) return;
  window.__mydSizeChartBound = true;

  const OPEN_SEL =
    '.cl-size-chart-btn, [data-cl-size-chart-btn], [data-myd-qa-size-chart], .myd-search-qa__size-chart, .pdp-size-chart-link';

  const DEFAULT_NOTES = [
    'The fabric has a moderate stretch for added comfort',
    'If the size is not right, we offer easy exchanges',
    'Sizes may vary ±0.5 inches',
  ];

  const HEADER_MAP = [
    [/garment\s*chest|body\s*chest|chest\s*circumference|^chest$/i, 'Chest'],
    [/garment\s*length|^length$/i, 'Length'],
    [/shoulder\s*width|^shoulder$/i, 'Shoulder'],
    [/sleeve\s*length|^sleeve$/i, 'Sleeve'],
    [/^size$|^sizes?$/i, 'Size'],
  ];

  let root;
  let host;
  let unit = 'in';
  let lastProductKey = '';
  let loadSeq = 0;
  let busyBtn = null;
  let activeProduct = null;
  let toastTimer = null;
  // Prefer one Kiwi chart when a product matches several (e.g. Kurta + Kurta Top / Pant / Saree)
  let activeChartPreference = ['kurta', 'shirt', 'tee', 'top', 'size'];
  // Last multi-chart payload (for garment tab switching)
  let activeChartBundle = null;
  // Kiwi getSizingChart names for the active product: [{ name, fp }]
  let activeKiwiChartNames = [];
  const kiwiNameCache = Object.create(null);
  // Parsed Kiwi tables by product id — avoids PDP→YML reload races
  const chartCache = Object.create(null);
  // How-to-Measure media by product id (unit-independent)
  const htmCache = Object.create(null);
  // Frozen at first read — never use KiwiSizing.data here (YML sync pollutes it)
  let stablePageProductId = null;

  function captureStablePageProductId() {
    if (stablePageProductId != null) return stablePageProductId;
    try {
      const id = window.ShopifyAnalytics?.meta?.product?.id || window.meta?.product?.id;
      if (id != null) stablePageProductId = id;
    } catch (e) {}
    return stablePageProductId;
  }

  function showToast(message, kind) {
    if (!ensureDom()) return;
    let toast = root.querySelector('[data-myd-sc-toast]');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'myd-sc__toast';
      toast.setAttribute('data-myd-sc-toast', '');
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      const sheet = root.querySelector('[data-myd-sc-sheet]');
      (sheet || root).appendChild(toast);
    }
    toast.textContent = message || '';
    toast.classList.remove('myd-sc__toast--error', 'myd-sc__toast--ok', 'is-visible');
    if (kind === 'ok') toast.classList.add('myd-sc__toast--ok');
    else toast.classList.add('myd-sc__toast--error');
    toast.hidden = false;
    // Force reflow so transition plays
    void toast.offsetWidth;
    toast.classList.add('is-visible');
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
      toastTimer = setTimeout(function () {
        toast.hidden = true;
      }, 200);
    }, 2200);
  }

  function $(sel, el) {
    return (el || root).querySelector(sel);
  }

  function ensureDom() {
    root = document.getElementById('myd-size-chart');
    host = document.getElementById('myd-sc-kiwi-host');
    return !!(root && host);
  }

  function setBusy(on) {
    if (!busyBtn) return;
    if (on) busyBtn.setAttribute('aria-busy', 'true');
    else busyBtn.removeAttribute('aria-busy');
  }

  function normalizeHeader(text) {
    const t = String(text || '')
      .replace(/\s+/g, ' ')
      .trim();
    if (!t) return '';
    for (let i = 0; i < HEADER_MAP.length; i++) {
      if (HEADER_MAP[i][0].test(t)) return HEADER_MAP[i][1];
    }
    return t.replace(/\b\w/g, (c) => c.toUpperCase());
  }

  function cellText(el) {
    return (el?.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function chartPreferenceFromButton(btn) {
    const fieldset = btn?.closest?.('.variant-input-wrapper, [data-option-slug]');
    const slug = String(
      fieldset?.getAttribute?.('data-option-slug') ||
        fieldset?.dataset?.optionSlug ||
        ''
    ).toLowerCase();
    const legend = String(fieldset?.querySelector?.('legend')?.textContent || '').toLowerCase();
    const text = slug + ' ' + legend;
    if (/saree|dupatta|shawl/.test(text)) return ['saree', 'dupatta', 'shawl'];
    if (/pant|trouser|bottom|waist|pyjama|pajama/.test(text)) {
      return ['pant', 'trouser', 'bottom', 'waist', 'pyjama'];
    }
    if (/kurta|shirt|tee|top|blouse/.test(text)) {
      return ['kurta', 'shirt', 'tee', 'top', 'blouse'];
    }
    // Default Size Chart link on couple combos sits on Kurta
    return ['kurta', 'shirt', 'tee', 'top', 'size'];
  }

  function chartWrapFor(table) {
    if (!table) return null;
    // Climb past .ks-table-wrapper so How-to-Measure (sibling tab panel) is
    // included. Stop before a shared parent that holds Kurta + Saree together.
    let el = table.parentElement;
    let best = table;
    while (el && el !== document.body) {
      if (host && el === host) break;
      const tables = Array.prototype.slice
        .call(el.querySelectorAll('.ks-table, table.ks-table'))
        .filter(function (t) {
          return collectRows(t).length >= 2;
        });
      if (tables.length > 1) break;
      best = el;
      if (
        el.classList &&
        (el.classList.contains('ks-chart-individual') ||
          el.classList.contains('ks-tab') ||
          el.classList.contains('ks-chart-tab-container') ||
          el.classList.contains('ks-chart-container') ||
          el.classList.contains('kiwi-sizing-modal-inner'))
      ) {
        return el;
      }
      el = el.parentElement;
    }
    return best;
  }

  function collectChartTables(rootEl) {
    if (!rootEl || !rootEl.querySelectorAll) return [];
    return Array.prototype.slice
      .call(rootEl.querySelectorAll('.ks-table, table.ks-table'))
      .filter(function (table) {
        return collectRows(table).length >= 2;
      });
  }

  function uniqueChartWraps(rootEl) {
    const tables = collectChartTables(rootEl);
    const wraps = [];
    const seen = [];
    tables.forEach(function (table) {
      const wrap = chartWrapFor(table) || table;
      if (seen.indexOf(wrap) !== -1) return;
      // Skip if this wrap is already represented by a tighter child wrap
      if (
        seen.some(function (other) {
          return wrap.contains && wrap.contains(other) && other !== wrap;
        })
      ) {
        return;
      }
      // Drop any looser wrap we already stored that contains this one
      for (let i = seen.length - 1; i >= 0; i--) {
        if (seen[i].contains && seen[i].contains(wrap) && seen[i] !== wrap) {
          seen.splice(i, 1);
          wraps.splice(i, 1);
        }
      }
      seen.push(wrap);
      wraps.push(wrap);
    });
    return wraps;
  }

  function titleNearTable(table) {
    const wrap = chartWrapFor(table) || table;
    if (!wrap) return '';
    const candidates = [];
    if (wrap.querySelectorAll) {
      Array.prototype.push.apply(
        candidates,
        wrap.querySelectorAll(
          'h1, h2, h3, h4, .ks-chart-title, .ks-product-title, [class*="chart-name"], [class*="chart-title"]'
        )
      );
    }
    let prev = wrap.previousElementSibling;
    for (let i = 0; i < 3 && prev; i++) {
      candidates.push(prev);
      prev = prev.previousElementSibling;
    }
    for (let i = 0; i < candidates.length; i++) {
      const t = cellText(candidates[i]);
      if (!t || t.length > 60) continue;
      if (/edit\s*chart|how\s*to\s*measure|^note$|inches|^cm$/i.test(t)) continue;
      // Do not treat column headers (Waist, Chest, …) as chart titles
      if (/^(waist|hip|inseam|outseam|chest|shoulder|sleeve|length|size|sizes)$/i.test(t)) continue;
      if (/kurta|saree|pant|shirt|dress|tee|top|blouse/i.test(t)) return t;
      if (!/size\s*chart|select|add/i.test(t)) return t;
    }
    return '';
  }

  function headerFingerprint(headers) {
    return (headers || [])
      .map(function (h) {
        return String(h || '')
          .toLowerCase()
          .replace(/\s+/g, ' ')
          .trim();
      })
      .filter(Boolean)
      .join('|');
  }

  function sizingHeaderFingerprint(sizing) {
    const tables = (sizing && sizing.tables) || {};
    const keys = Object.keys(tables);
    for (let i = 0; i < keys.length; i++) {
      const data = (tables[keys[i]] && tables[keys[i]].data) || [];
      if (!data[0] || !data[0].length) continue;
      return data[0]
        .map(function (c) {
          return String((c && c.value) || '')
            .toLowerCase()
            .replace(/\s+/g, ' ')
            .trim();
        })
        .filter(Boolean)
        .join('|');
    }
    return '';
  }

  function fetchKiwiSizingNames(product) {
    const id = productKey(product);
    if (id && kiwiNameCache[id]) return Promise.resolve(kiwiNameCache[id]);
    const shop =
      (window.Shopify && window.Shopify.shop) || 'mydesignation-store.myshopify.com';
    const tags = Array.isArray(product?.tags) ? product.tags.join(',') : product?.tags || '';
    const payload = {
      shop: shop,
      product: id ? Number(id) : undefined,
      productID: id ? Number(id) : undefined,
      title: product?.title || '',
      tags: tags,
      type: product?.type || product?.product_type || '',
      vendor: product?.vendor || '',
    };
    return fetch('https://app.kiwisizing.com/api/getSizingChart', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (d) {
        const list = (d.sizings || [])
          .filter(function (s) {
            return s && s.isEnabled !== false && s.name;
          })
          .map(function (s) {
            return { name: String(s.name), fp: sizingHeaderFingerprint(s) };
          });
        if (id) kiwiNameCache[id] = list;
        return list;
      })
      .catch(function () {
        return [];
      });
  }

  function kiwiApiNameForParsed(parsed) {
    if (!parsed || !activeKiwiChartNames.length) return '';
    const fp = headerFingerprint(parsed.headers);
    if (!fp) return '';
    for (let i = 0; i < activeKiwiChartNames.length; i++) {
      if (activeKiwiChartNames[i].fp === fp) return activeKiwiChartNames[i].name;
    }
    return '';
  }

  function chartHeaderText(parsed) {
    return ((parsed && parsed.headers) || []).join(' ').toLowerCase();
  }

  function looksLikeTopChart(parsed) {
    const headers = chartHeaderText(parsed);
    return /chest|shoulder|sleeve/.test(headers) && !/pallu/.test(headers);
  }

  function looksLikeSareeChart(parsed) {
    const headers = chartHeaderText(parsed);
    return /pallu|blouse length/.test(headers) || (/saree/.test(headers) && !looksLikeTopChart(parsed));
  }

  function looksLikePantChart(parsed) {
    const headers = chartHeaderText(parsed);
    return /waist|hip|inseam|thigh/.test(headers) && !/chest|shoulder|sleeve/.test(headers);
  }

  function productTitleText() {
    return String(activeProduct?.title || activeProduct?.name || '').toLowerCase();
  }

  function pantFallbackLabel() {
    const title = productTitleText();
    const tags = String(activeProduct?.tags || '').toLowerCase();
    if (/kurta/.test(title) || /kiwi_kurta_pants/.test(tags)) return 'Kurta Pants';
    return 'Pant';
  }

  function defaultSecondGarmentLabel(parsed) {
    if (looksLikeSareeChart(parsed)) return 'Saree';
    if (looksLikePantChart(parsed)) return pantFallbackLabel();
    if (looksLikeTopChart(parsed)) return 'Kurta';
    const title = productTitleText();
    if (/saree|couple/.test(title) && !/pant|kurta\s*top|shirt/.test(title)) return 'Saree';
    if (/pant|bottom/.test(title)) return pantFallbackLabel();
    return 'Kurta';
  }

  function cleanKiwiTitle(raw) {
    return String(raw || '')
      .replace(/\s*size\s*chart\s*/i, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, 40);
  }

  function niceGarmentLabel(raw, index, parsed) {
    // 1) Exact Kiwi API chart name  2) DOM title near table  3) header heuristics
    const fromApi = cleanKiwiTitle(kiwiApiNameForParsed(parsed));
    if (fromApi) return fromApi;
    const cleaned = cleanKiwiTitle(raw);
    if (cleaned) return cleaned;
    if (looksLikeSareeChart(parsed)) return 'Saree';
    if (looksLikePantChart(parsed)) return pantFallbackLabel();
    if (looksLikeTopChart(parsed)) return 'Kurta';
    if (index === 0) return 'Kurta';
    if (index === 1) return defaultSecondGarmentLabel(parsed);
    return 'Chart ' + (index + 1);
  }

  function scoreChartContext(text, keywords) {
    const hay = String(text || '').toLowerCase();
    if (!hay) return 0;
    let score = 0;
    (keywords || []).forEach(function (k, i) {
      if (hay.indexOf(k) !== -1) score += Math.max(1, 12 - i);
    });
    if (/saree/.test(hay) && !(keywords || []).some(function (k) { return k.indexOf('saree') !== -1; })) {
      score -= 8;
    }
    if (/kurta/.test(hay) && (keywords || []).some(function (k) { return k.indexOf('saree') !== -1; })) {
      score -= 4;
    }
    return score;
  }

  function findFirstKiwiTable(scope) {
    const rootEl = scope || host || document.getElementById('myd-sc-kiwi-host');
    if (!rootEl || rootEl === document) {
      return (
        document.querySelector('#myd-sc-kiwi-host .ks-table') ||
        document.querySelector('#myd-sc-kiwi-host table.ks-table') ||
        document.querySelector('#myd-sc-kiwi-host table') ||
        null
      );
    }
    return (
      rootEl.querySelector('.ks-table') ||
      rootEl.querySelector('table.ks-table') ||
      rootEl.querySelector('table') ||
      null
    );
  }

  function findPreferredKiwiTable(scope, keywords) {
    const rootEl = scope || host || document;
    const prefs = keywords && keywords.length ? keywords : activeChartPreference;
    const wraps = uniqueChartWraps(rootEl);
    let bestTable = null;
    let bestScore = -Infinity;
    wraps.forEach(function (wrap) {
      const table = wrap.querySelector?.('.ks-table, table.ks-table, table') || wrap;
      if (collectRows(table).length < 2) return;
      const ctx = (titleNearTable(table) + ' ' + cellText(wrap)).slice(0, 800);
      const score = scoreChartContext(ctx, prefs);
      if (score > bestScore) {
        bestScore = score;
        bestTable = table;
      }
    });
    if (bestTable && bestScore > 0) return bestTable;
    return findFirstKiwiTable(scope);
  }

  function findKiwiTable(scope) {
    return findPreferredKiwiTable(scope, activeChartPreference) || findFirstKiwiTable(scope);
  }

  function pickActiveChartIndex(charts) {
    if (!charts || !charts.length) return 0;
    let best = 0;
    let bestScore = -Infinity;
    charts.forEach(function (chart, i) {
      const score = scoreChartContext(chart.title || '', activeChartPreference);
      if (score > bestScore) {
        bestScore = score;
        best = i;
      }
    });
    return best;
  }

  function parseAllChartsFrom(scope) {
    const rootEl = scope || host;
    if (!rootEl) return null;
    // Parse every table — not one table per shared parent wrap
    let tables = collectChartTables(rootEl);
    // If host only captured one chart, also scan live Kiwi mounts on the page
    if (tables.length < 2 && rootEl === host) {
      const liveRoots = [
        document.querySelector('.kiwi-sizing-modal'),
        document.querySelector('.ks-chart-tab-container'),
        document.querySelector('.ks-calculator-container'),
        document.body,
      ].filter(Boolean);
      const extra = [];
      liveRoots.forEach(function (live) {
        collectChartTables(live).forEach(function (table) {
          if (extra.indexOf(table) === -1 && tables.indexOf(table) === -1) extra.push(table);
        });
      });
      if (extra.length) tables = tables.concat(extra);
    }
    const charts = [];
    const seen = Object.create(null);
    tables.forEach(function (table, i) {
      const parsed = parseTable(table);
      if (!parsed) return;
      const title = niceGarmentLabel(titleNearTable(table), i, parsed);
      const fp =
        (parsed.headers || []).join('|') +
        '||' +
        parsed.body
          .map(function (row) {
            return (row || []).join('|');
          })
          .join(';;');
      if (seen[fp]) return;
      seen[fp] = true;
      charts.push({
        title: title,
        headers: parsed.headers,
        body: parsed.body,
      });
    });
    // Fix mistaken "Saree" when the table is clearly a top/pant chart
    charts.forEach(function (c) {
      if (!/^saree$/i.test(c.title)) return;
      if (looksLikeSareeChart(c)) return;
      if (looksLikePantChart(c)) c.title = pantFallbackLabel();
      else if (looksLikeTopChart(c)) c.title = 'Kurta';
    });
    // Only fill gaps when Kiwi left no usable title — never overwrite Kiwi names
    if (charts.length === 2) {
      const bothGeneric = charts.every(function (c) {
        return /^chart\s*\d+$/i.test(c.title);
      });
      if (bothGeneric) {
        charts[0].title = looksLikePantChart(charts[0]) ? pantFallbackLabel() : 'Kurta';
        charts[1].title = defaultSecondGarmentLabel(charts[1]);
      }
      if (!charts[0].title || /^chart\s*\d+$/i.test(charts[0].title)) {
        charts[0].title = looksLikePantChart(charts[0]) ? pantFallbackLabel() : 'Kurta';
      }
      if (!charts[1].title || /^chart\s*\d+$/i.test(charts[1].title)) {
        charts[1].title = defaultSecondGarmentLabel(charts[1]);
      }
    }
    if (!charts.length) {
      const single = parseTable(findFirstKiwiTable(rootEl));
      if (!single) return null;
      return single;
    }
    if (charts.length === 1) {
      return {
        headers: charts[0].headers,
        body: charts[0].body,
        charts: charts,
        activeIndex: 0,
      };
    }
    const activeIndex = pickActiveChartIndex(charts);
    return {
      charts: charts,
      activeIndex: activeIndex,
      headers: charts[activeIndex].headers,
      body: charts[activeIndex].body,
    };
  }

  /** Any parseable Kiwi table currently in the document (host preferred). */
  function findLiveKiwiTable() {
    return (
      findKiwiTable(host) ||
      document.querySelector('#myd-sc-kiwi-host .ks-table') ||
      document.querySelector('.kiwi-sizing-modal .ks-table') ||
      document.querySelector('.ks-chart-tab-container .ks-table') ||
      document.querySelector('.ks-table-wrapper .ks-table') ||
      document.querySelector('.ks-table') ||
      null
    );
  }

  function fingerprintTable(table) {
    if (!table) return '';
    try {
      return collectRows(table)
        .map(function (r) {
          return r.join('\t');
        })
        .join('\n')
        .slice(0, 800);
    } catch (e) {
      return '';
    }
  }

  function snapshotPageKiwiTables() {
    const nodes = Array.prototype.slice.call(document.querySelectorAll('.ks-table'));
    return {
      nodes: new Set(nodes),
      fingerprint: fingerprintTable(findLiveKiwiTable()),
    };
  }

  function findReloadedKiwiTable(before) {
    const hostTable = findKiwiTable(host);
    if (hostTable && collectRows(hostTable).length >= 2) return hostTable;

    const nodes = document.querySelectorAll(
      '#myd-sc-kiwi-host .ks-table, .kiwi-sizing-modal .ks-table, .ks-chart-tab-container .ks-table, .ks-table-wrapper .ks-table, .ks-table'
    );
    for (let i = 0; i < nodes.length; i++) {
      const table = nodes[i];
      if (host && host.contains(table)) {
        if (collectRows(table).length >= 2) return table;
        continue;
      }
      if (!before) {
        if (collectRows(table).length >= 2) return table;
        continue;
      }
      // New DOM node after reload
      if (before.nodes && !before.nodes.has(table) && collectRows(table).length >= 2) {
        return table;
      }
      // Same node but Kiwi swapped the rows for the new product
      if (collectRows(table).length >= 2) {
        const fp = fingerprintTable(table);
        if (fp && before.fingerprint && fp !== before.fingerprint) return table;
      }
    }
    return null;
  }

  function clearPageKiwiMounts() {
    document
      .querySelectorAll(
        '.ks-chart-container, .ks-calculator-container, .kiwi-sizing-chart-button-container, #kiwi-sizing-chart-button, .ks-chart-tab-container, .ks-table-wrapper'
      )
      .forEach(function (el) {
        if (host && host.contains(el)) return;
        try {
          el.remove();
        } catch (err) {}
      });
  }

  function rewarmPdpKiwi(snap) {
    if (!snap) return;
    try {
      restoreKiwiState(snap);
      window._ks_sizingLoaded = false;
      if (typeof window.loadKiwiSizingChart === 'function') {
        window.loadKiwiSizingChart({});
      }
    } catch (e) {}
  }

  function rowCells(row) {
    const direct = row.querySelectorAll(
      ':scope > .ks-table-cell, :scope > .ks-table-header-cell, :scope > th, :scope > td'
    );
    if (direct.length) return Array.prototype.slice.call(direct);
    return Array.prototype.slice.call(
      row.querySelectorAll('.ks-table-cell, .ks-table-header-cell, th, td')
    );
  }

  function collectRows(table) {
    const rows = [];
    // Kiwi div-based table
    const divRows = table.querySelectorAll('.ks-table-row');
    if (divRows.length) {
      divRows.forEach(function (row) {
        const cells = rowCells(row).map(cellText);
        if (cells.some(Boolean)) rows.push(cells);
      });
      return rows;
    }
    // Native HTML table
    const trs = table.querySelectorAll('tr');
    trs.forEach(function (tr) {
      const cells = Array.prototype.map.call(tr.querySelectorAll('th, td'), cellText);
      if (cells.some(Boolean)) rows.push(cells);
    });
    return rows;
  }

  function parseTable(table) {
    if (!table) return null;
    const rows = collectRows(table);
    if (rows.length < 2) return null;

    const headers = rows[0].map(normalizeHeader);
    if (!headers.some(Boolean)) return null;

    const body = rows.slice(1).map(function (r) {
      const out = [];
      for (let i = 0; i < headers.length; i++) out.push(r[i] != null ? r[i] : '');
      return out;
    });
    if (!body.length) return null;
    return { headers: headers, body: body };
  }

  function waitForTable(ms, scope) {
    ms = ms || 2500;
    const rootEl = scope || host || document.getElementById('myd-sc-kiwi-host');
    return new Promise(function (resolve) {
      const start = Date.now();
      const tick = function () {
        const table = scope ? findKiwiTable(rootEl) : findLiveKiwiTable();
        if (table && collectRows(table).length >= 2) {
          if (!scope || !rootEl || rootEl === document || rootEl.contains(table)) {
            resolve(table);
            return;
          }
        }
        if (Date.now() - start >= ms) {
          resolve(scope ? findKiwiTable(rootEl) : findLiveKiwiTable());
          return;
        }
        setTimeout(tick, 40);
      };
      tick();
    });
  }

  function waitForReloadedTable(before, ms) {
    ms = ms || 3500;
    return new Promise(function (resolve) {
      const start = Date.now();
      const tick = function () {
        const table = findReloadedKiwiTable(before);
        if (table) {
          resolve(adoptTableIntoHost(table) || table);
          return;
        }
        if (Date.now() - start >= ms) {
          resolve(findKiwiTable(host) || findReloadedKiwiTable(before) || findLiveKiwiTable());
          return;
        }
        setTimeout(tick, 40);
      };
      tick();
    });
  }

  function adoptTableIntoHost(table) {
    if (!host || !table) return null;
    if (host.contains(table) && uniqueChartWraps(host).length) {
      return findFirstKiwiTable(host);
    }
    try {
      // Keep every Kiwi chart block (Kurta + Saree on couple combos)
      const searchRoot =
        table.closest?.('.kiwi-sizing-modal, .ks-calculator-container, .ks-chart-container, body') ||
        table.ownerDocument?.body ||
        document.body;
      let wraps = uniqueChartWraps(searchRoot);
      if (!wraps.length) {
        const one = chartWrapFor(table) || table;
        wraps = [one];
      }
      let injectEl = host.querySelector('#myd-kiwi-inject') || host.querySelector('#KiwiSizingChart');
      if (!injectEl) {
        host.innerHTML = '';
        injectEl = document.createElement('div');
        injectEl.id = 'myd-kiwi-inject';
        host.appendChild(injectEl);
      } else {
        injectEl.innerHTML = '';
      }
      wraps.forEach(function (wrap) {
        injectEl.appendChild(wrap.cloneNode(true));
      });
      return findFirstKiwiTable(host);
    } catch (e) {
      return null;
    }
  }

  function parseNotes() {
    if (!host) return DEFAULT_NOTES.slice();
    // Prefer notes from the Size Chart tab (not How to Measure copy)
    const chartPanel =
      findSizeChartPanel(host) ||
      host.querySelector('.ks-tab-panel.selected') ||
      host;
    const box =
      chartPanel.querySelector('.ks-table-footer') ||
      chartPanel.querySelector('.ks-html-content') ||
      chartPanel.querySelector('.ks-chart-notes') ||
      host.querySelector('.ks-table-footer') ||
      host.querySelector('.ks-html-content') ||
      host.querySelector('.ks-chart-notes');
    if (!box) return DEFAULT_NOTES.slice();
    const lis = box.querySelectorAll('li');
    if (lis.length) {
      return Array.prototype.map.call(lis, cellText).filter(Boolean);
    }
    const text = cellText(box);
    if (!text || text.length < 8) return DEFAULT_NOTES.slice();
    return text
      .split(/\n|•|·/)
      .map((s) => s.replace(/^note:?\s*/i, '').trim())
      .filter((s) => s && s.length > 3)
      .slice(0, 6);
  }

  function resolveKiwiImgSrc(img) {
    if (!img) return '';
    const raw =
      img.getAttribute('src') ||
      img.getAttribute('data-src') ||
      img.getAttribute('data-original') ||
      img.getAttribute('data-lazy-src') ||
      '';
    return String(raw || '')
      .trim()
      .replace(/^\/\//, 'https://');
  }

  function findKiwiTabPanelByHeader(scope, pattern) {
    const rootEl = scope || host;
    if (!rootEl) return null;
    const headers = rootEl.querySelectorAll('.ks-tab-header');
    let idx = -1;
    for (let i = 0; i < headers.length; i++) {
      if (pattern.test(cellText(headers[i]))) {
        idx = i;
        break;
      }
    }
    const panels = rootEl.querySelectorAll('.ks-tab-panel');
    if (idx >= 0 && panels[idx]) return panels[idx];
    return null;
  }

  function findSizeChartPanel(scope) {
    return findKiwiTabPanelByHeader(scope, /size\s*chart/i);
  }

  function findHowToMeasurePanel(scope) {
    const byHeader = findKiwiTabPanelByHeader(scope, /how\s*to\s*measure/i);
    if (byHeader) return byHeader;
    const rootEl = scope || host;
    if (!rootEl) return null;
    const panels = rootEl.querySelectorAll('.ks-tab-panel');
    for (let i = 0; i < panels.length; i++) {
      const panel = panels[i];
      if (panel.querySelector('.ks-table')) continue;
      if (panel.querySelector('.ks-image-and-caption, .image-block img, img[data-src], img[src]')) {
        return panel;
      }
    }
    return null;
  }

  function parseHowToMeasure(scope) {
    const panel = findHowToMeasurePanel(scope);
    if (!panel) return null;
    const img =
      panel.querySelector('.image-block img') ||
      panel.querySelector('.ks-image-and-caption img') ||
      panel.querySelector('img');
    const imageSrc = resolveKiwiImgSrc(img);
    let items = [];
    const lis = panel.querySelectorAll('.text-block li, .ks-html-content li, ul li');
    if (lis.length) {
      items = Array.prototype.map.call(lis, cellText).filter(Boolean);
    }
    if (!imageSrc && !items.length) return null;
    return { imageSrc: imageSrc, items: items };
  }

  function liveKiwiHowToMeasureScopes() {
    return [
      document.querySelector('.kiwi-sizing-modal'),
      document.querySelector('.ks-chart-tab-container'),
      document.querySelector('.ks-calculator-container'),
      document.querySelector('.kiwi-sizing-modal-hidden-container'),
      document.body,
    ].filter(Boolean);
  }

  function attachHowToMeasure(parsed, productId) {
    if (!parsed) return parsed;
    const id = productId != null ? String(productId) : '';
    let htm = parseHowToMeasure(host);
    // Host may only have the size table if an older tight wrap was cached —
    // fall back to the live Kiwi modal, which still has How to Measure.
    if (!htm || !htm.imageSrc) {
      const scopes = liveKiwiHowToMeasureScopes();
      for (let i = 0; i < scopes.length; i++) {
        const live = parseHowToMeasure(scopes[i]);
        if (live && live.imageSrc) {
          htm = live;
          break;
        }
        if (!htm && live) htm = live;
      }
    }
    if (!htm && id && htmCache[id]) htm = htmCache[id];
    if (htm) {
      parsed.htm = htm;
      if (id) htmCache[id] = htm;
    }
    return parsed;
  }

  function renderHowToMeasure(htm) {
    if (!ensureDom()) return;
    const kiwiBox = $('[data-myd-sc-htm-kiwi]');
    const fallback = $('[data-myd-sc-htm-fallback]');
    if (!kiwiBox || !fallback) return;

    if (!htm || (!htm.imageSrc && !(htm.items && htm.items.length))) {
      kiwiBox.hidden = true;
      kiwiBox.innerHTML = '';
      fallback.hidden = false;
      return;
    }

    let html = '';
    if (htm.imageSrc) {
      html +=
        '<img class="myd-sc__diagram myd-sc__diagram--kiwi" src="' +
        escapeHtml(htm.imageSrc) +
        '" alt="How to measure" loading="lazy" decoding="async" />';
    }
    if (htm.items && htm.items.length) {
      html +=
        '<ul class="myd-sc__htm-list">' +
        htm.items
          .map(function (item) {
            const m = String(item).match(/^([^:]{1,48}):\s*(.+)$/);
            if (m) {
              return (
                '<li><strong>' +
                escapeHtml(m[1]) +
                ':</strong> ' +
                escapeHtml(m[2]) +
                '</li>'
              );
            }
            return '<li>' + escapeHtml(item) + '</li>';
          })
          .join('') +
        '</ul>';
    } else {
      const fallbackList = fallback.querySelector('.myd-sc__htm-list');
      if (fallbackList) html += fallbackList.outerHTML;
    }

    kiwiBox.innerHTML = html;
    kiwiBox.hidden = false;
    fallback.hidden = true;
  }

  function ensureGarmentBar() {
    if (!ensureDom()) return null;
    let bar = $('[data-myd-sc-garments]');
    if (bar) return bar;
    const wrap = $('[data-myd-sc-table-wrap]');
    if (!wrap || !wrap.parentElement) return null;
    bar = document.createElement('div');
    bar.className = 'myd-sc__garments';
    bar.setAttribute('data-myd-sc-garments', '');
    bar.setAttribute('role', 'tablist');
    bar.setAttribute('aria-label', 'Garment size charts');
    bar.hidden = true;
    wrap.parentElement.insertBefore(bar, wrap);
    return bar;
  }

  function renderGarmentTabs(data) {
    const bar = ensureGarmentBar();
    if (!bar) return;
    const charts = data && data.charts;
    if (!charts || charts.length < 2) {
      bar.hidden = true;
      bar.innerHTML = '';
      return;
    }
    const active = data.activeIndex || 0;
    bar.hidden = false;
    bar.innerHTML = charts
      .map(function (chart, i) {
        return (
          '<button type="button" class="myd-sc__garment' +
          (i === active ? ' is-active' : '') +
          '" role="tab" aria-selected="' +
          (i === active ? 'true' : 'false') +
          '" data-myd-sc-garment="' +
          i +
          '">' +
          escapeHtml(chart.title || 'Chart ' + (i + 1)) +
          '</button>'
        );
      })
      .join('');
  }

  function selectGarmentChart(index) {
    if (!activeChartBundle || !activeChartBundle.charts) return;
    const charts = activeChartBundle.charts;
    const n = Number(index);
    const idx = Math.max(0, Math.min(charts.length - 1, Number.isFinite(n) ? n : 0));
    if (idx === activeChartBundle.activeIndex) {
      // Still refresh tab UI in case it was out of sync
      renderGarmentTabs(activeChartBundle);
      return;
    }
    activeChartBundle.activeIndex = idx;
    activeChartBundle.headers = charts[idx].headers;
    activeChartBundle.body = charts[idx].body;
    renderTable(activeChartBundle);
  }

  function renderTable(data) {
    const table = $('[data-myd-sc-table]');
    const thead = $('[data-myd-sc-thead]');
    const tbody = $('[data-myd-sc-tbody]');
    const loading = $('[data-myd-sc-loading]');
    const error = $('[data-myd-sc-error]');
    const noteList = $('[data-myd-sc-note-list]');
    const note = $('[data-myd-sc-note]');
    if (!table || !thead || !tbody) return;

    if (loading) loading.hidden = true;
    if (error) error.hidden = true;

    if (!data) {
      activeChartBundle = null;
      renderGarmentTabs(null);
      table.hidden = true;
      if (note) note.hidden = true;
      if (error) error.hidden = false;
      renderHowToMeasure(null);
      return;
    }

    if (data.charts && data.charts.length) {
      activeChartBundle = data;
      const idx = Math.min(data.activeIndex || 0, data.charts.length - 1);
      data.activeIndex = idx;
      data.headers = data.charts[idx].headers;
      data.body = data.charts[idx].body;
    } else {
      activeChartBundle = null;
    }
    renderGarmentTabs(data);

    thead.innerHTML =
      '<tr>' + data.headers.map((h) => '<th scope="col">' + escapeHtml(h) + '</th>').join('') + '</tr>';
    tbody.innerHTML = data.body
      .map(function (row) {
        const size = row[0] || '';
        const cells = row
          .map(function (c, i) {
            if (i === 0) {
              return (
                '<th scope="row" class="myd-sc__size-cell">' +
                '<label class="myd-sc__size-option">' +
                '<input type="radio" class="myd-sc__size-radio" name="myd-sc-size" value="' +
                escapeHtml(size) +
                '" data-myd-sc-size="' +
                escapeHtml(size) +
                '" />' +
                '<span class="myd-sc__size-ui" aria-hidden="true"></span>' +
                '<span class="myd-sc__size-label">' +
                escapeHtml(size) +
                '</span>' +
                '</label>' +
                '</th>'
              );
            }
            return '<td>' + escapeHtml(c) + '</td>';
          })
          .join('');
        return '<tr>' + cells + '</tr>';
      })
      .join('');
    table.hidden = false;
    if (note) note.hidden = false;

    if (noteList) {
      const notes = parseNotes();
      noteList.innerHTML = notes.map((n) => '<li>' + escapeHtml(n) + '</li>').join('');
    }

    renderHowToMeasure(data.htm || null);
    syncSelectedSizeUi(getCurrentlySelectedSizeLabel());
  }

  function getCurrentlySelectedSizeLabel() {
    const qa = document.querySelector('myd-search-quick-add');
    if (qa && typeof qa.isOpen === 'function' && qa.isOpen()) {
      const selected = qa.querySelector?.('.myd-search-qa__variant-btn.selected');
      if (selected?.textContent) return selected.textContent.trim();
    }

    const sizeFs = findSizeFieldset();
    const checked = sizeFs?.querySelector('input[type="radio"]:checked');
    return checked?.value || checked?.getAttribute('data-option-value') || '';
  }

  function syncSelectedSizeUi(sizeLabel) {
    if (!root) return;
    root.querySelectorAll('[data-myd-sc-size]').forEach(function (input) {
      const on = sizeLabel && sizeKeysMatch(input.getAttribute('data-myd-sc-size'), sizeLabel);
      input.checked = !!on;
      input.closest('.myd-sc__size-option')?.classList.toggle('is-selected', !!on);
      input.closest('tr')?.classList.toggle('is-size-selected', !!on);
    });
  }

  function findSizeFieldset() {
    const rootEl = document.querySelector('variant-radios, variant-selects');
    if (!rootEl) return null;
    return (
      Array.from(rootEl.querySelectorAll('fieldset.variant-input-wrapper, fieldset')).find(function (fs) {
        if (fs.dataset.combinedListingOption === 'true') return false;
        const slug = (fs.dataset.optionSlug || '').toLowerCase();
        const legend = (fs.querySelector('legend')?.textContent || '').toLowerCase();
        return slug.includes('size') || legend.includes('size');
      }) || null
    );
  }

  function selectSizeOnPdp(sizeLabel) {
    const fieldset = findSizeFieldset();
    if (!fieldset) return false;
    const inputs = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
    const match = inputs.find(function (input) {
      return (
        sizeKeysMatch(input.value, sizeLabel) ||
        sizeKeysMatch(input.getAttribute('data-option-value'), sizeLabel)
      );
    });
    if (!match) return false;
    if (match.disabled && match.classList.contains('disabled') && match.getAttribute('disabled') !== null) {
      // Sold-out sizes stay selectable on this theme (disabled attr used for sold-out styling).
      // Still allow selection so PDP matches chart choice.
    }
    match.checked = true;
    match.dispatchEvent(new Event('change', { bubbles: true }));
    match.dispatchEvent(new Event('input', { bubbles: true }));
    if (window.MYDSizeGate?.clearSizeWarning) window.MYDSizeGate.clearSizeWarning();
    return true;
  }

  function selectSizeOnQuickAdd(sizeLabel) {
    const qa = document.querySelector('myd-search-quick-add');
    if (!qa || typeof qa.isOpen !== 'function' || !qa.isOpen()) return false;
    const buttons = Array.from(qa.querySelectorAll('.myd-search-qa__variant-btn'));
    const match = buttons.find(function (btn) {
      return !btn.disabled && sizeKeysMatch(btn.textContent, sizeLabel);
    });
    if (!match) return false;
    match.click();
    return true;
  }

  function selectSizeFromChart(sizeLabel, inputEl) {
    if (!sizeLabel) return;
    const okQa = selectSizeOnQuickAdd(sizeLabel);
    const okPdp = okQa ? false : selectSizeOnPdp(sizeLabel);
    if (!okQa && !okPdp) {
      showToast('Size ' + sizeLabel + ' is not available', 'error');
      return;
    }
    syncSelectedSizeUi(sizeLabel);
    closeSheet();
  }

  function normalizeSizeKey(value) {
    let s = String(value || '')
      .trim()
      .toUpperCase()
      .replace(/\s+/g, '')
      .replace(/[-_]/g, '');
    // Chart ↔ Shopify aliasing
    if (s === 'XXXL' || s === '3X') s = '3XL';
    if (s === 'XXL' || s === '2X') s = '2XL';
    if (s === 'XXXXL' || s === '4X') s = '4XL';
    if (s === 'XXXXXL' || s === '5X') s = '5XL';
    if (s === '2XL') s = '2XL';
    if (s === 'XXLARGE') s = '2XL';
    if (s === 'XXXLARGE') s = '3XL';
    if (s === 'XLARGE' || s === 'X-LARGE') s = 'XL';
    if (s === 'MED' || s === 'MEDIUM') s = 'M';
    if (s === 'SMALL') s = 'S';
    if (s === 'LARGE') s = 'L';
    if (s === 'XSMALL' || s === 'EXTRA SMALL') s = 'XS';
    return s;
  }

  function sizeKeysMatch(a, b) {
    const x = normalizeSizeKey(a);
    const y = normalizeSizeKey(b);
    if (!x || !y) return false;
    if (x === y) return true;
    // Allow "SIZEM" / "SIZE L" style labels after stripping a SIZE prefix
    const stripSize = function (s) {
      return s.indexOf('SIZE') === 0 ? s.slice(4) : s;
    };
    return stripSize(x) === stripSize(y);
  }

  function variantsFromPage() {
    try {
      const radios = document.querySelector('variant-radios, variant-selects');
      if (radios && typeof radios.getVariantData === 'function') {
        const list = radios.getVariantData();
        if (Array.isArray(list) && list.length) return list;
      }
    } catch (e) {}
    const scripts = document.querySelectorAll(
      'variant-radios script[type="application/json"], variant-selects script[type="application/json"], product-info script[type="application/json"]'
    );
    for (let i = 0; i < scripts.length; i++) {
      try {
        const parsed = JSON.parse(scripts[i].textContent);
        if (Array.isArray(parsed) && parsed.length && parsed[0].id) return parsed;
        if (parsed?.variants?.length) return parsed.variants;
      } catch (e) {}
    }
    return null;
  }

  function pageProductId() {
    captureStablePageProductId();
    if (stablePageProductId != null) return stablePageProductId;
    try {
      return window.ShopifyAnalytics?.meta?.product?.id || window.meta?.product?.id || null;
    } catch (e) {
      return null;
    }
  }

  function currentPdpContextId() {
    try {
      const radios = document.querySelector('variant-radios, variant-selects');
      if (radios && radios._clKiwiProductId) return String(radios._clKiwiProductId);
      if (radios && radios._clKiwiProduct?.id) return String(radios._clKiwiProduct.id);
    } catch (e) {}
    const pid = pageProductId();
    return pid != null ? String(pid) : null;
  }

  function snapshotKiwiState() {
    const snap = {
      data: window.KiwiSizing?.data ? Object.assign({}, window.KiwiSizing.data) : null,
      metaId: null,
      metaGid: null,
      metaType: null,
    };
    try {
      const meta = window.ShopifyAnalytics?.meta?.product;
      if (meta) {
        snap.metaId = meta.id;
        snap.metaGid = meta.gid;
        snap.metaType = meta.type;
      }
    } catch (e) {}
    return snap;
  }

  function restoreKiwiState(snap) {
    if (!snap) return;
    try {
      window.KiwiSizing = window.KiwiSizing || {};
      if (snap.data) window.KiwiSizing.data = Object.assign({}, snap.data);
      const meta = window.ShopifyAnalytics?.meta?.product;
      if (meta && snap.metaId != null) {
        meta.id = snap.metaId;
        if (snap.metaGid != null) meta.gid = snap.metaGid;
        if (snap.metaType != null) meta.type = snap.metaType;
      }
      if (window.meta?.product && snap.metaId != null) {
        window.meta.product.id = snap.metaId;
      }
    } catch (e) {}
  }

  async function ensureActiveProduct(product) {
    let p = product ? Object.assign({}, product) : {};
    const explicitId = p.id || p.product || null;
    const ctxId = currentPdpContextId();
    const sameAsPage =
      !explicitId || !ctxId || String(explicitId) === String(ctxId);

    // Only borrow PDP variants when we are actually charting the PDP product
    if ((!p.variants || !p.variants.length) && sameAsPage) {
      const pageVariants = variantsFromPage();
      if (pageVariants) p.variants = pageVariants;
    }

    // Always hydrate non-PDP (and incomplete) products from product.js.
    // Shopify Ajax JSON uses product_type (not type).
    const handle =
      p.handle || String(p.url || '').split('/products/')[1]?.split('?')[0]?.split('/')[0];
    const needsFetch =
      !!handle &&
      (!sameAsPage ||
        !p.variants ||
        !p.variants.length ||
        p.tags == null ||
        !(p.type || p.product_type));
    if (needsFetch) {
      try {
        const res = await fetch('/products/' + encodeURIComponent(handle) + '.js');
        if (res.ok) {
          const json = await res.json();
          p = Object.assign({}, p, json);
        }
      } catch (e) {}
    }

    // Normalize Ajax API → Kiwi field names
    if (!p.type && p.product_type) p.type = p.product_type;

    // QA cache fallback
    if ((!p.variants || !p.variants.length) && p.id) {
      const qa = document.querySelector('myd-search-quick-add');
      const cached = qa?._currentProduct;
      if (cached?.variants?.length && String(cached.id) === String(p.id)) {
        p = Object.assign({}, p, cached);
        if (!p.type && p.product_type) p.type = p.product_type;
      }
    }
    if (
      sameAsPage &&
      (!p.variants || !p.variants.length) &&
      window.KiwiSizing?.data?.variants?.length
    ) {
      p.variants = window.KiwiSizing.data.variants;
    }
    activeProduct = p;
    return p;
  }

  function findVariantForSize(product, sizeLabel) {
    const variants = product?.variants || [];
    if (!variants.length) return null;

    // Prefer exact option match on any option slot
    let match = variants.find(function (v) {
      return [v.option1, v.option2, v.option3].some(function (opt) {
        return sizeKeysMatch(opt, sizeLabel);
      });
    });
    if (match) return match;

    // Fallback: title / name
    match = variants.find(function (v) {
      return sizeKeysMatch(v.title, sizeLabel) || sizeKeysMatch(v.name, sizeLabel);
    });
    return match || null;
  }

  function openCartDrawer() {
    try {
      const details =
        document.querySelector('cart-drawer details') ||
        document.querySelector('details.mini-cart') ||
        document.querySelector('mini-cart details');
      if (details && !details.hasAttribute('open')) {
        const summary = details.querySelector('summary');
        summary?.click();
      }
    } catch (e) {}
  }

  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function showLoading() {
    const table = $('[data-myd-sc-table]');
    const loading = $('[data-myd-sc-loading]');
    const error = $('[data-myd-sc-error]');
    const note = $('[data-myd-sc-note]');
    const garments = $('[data-myd-sc-garments]');
    if (table) table.hidden = true;
    if (error) error.hidden = true;
    if (note) note.hidden = true;
    if (garments) garments.hidden = true;
    if (loading) loading.hidden = false;
  }

  function setTab(name) {
    root.querySelectorAll('[data-myd-sc-tab]').forEach((btn) => {
      const on = btn.getAttribute('data-myd-sc-tab') === name;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    root.querySelectorAll('[data-myd-sc-panel]').forEach((panel) => {
      const on = panel.getAttribute('data-myd-sc-panel') === name;
      panel.classList.toggle('is-active', on);
      panel.hidden = !on;
    });
  }

  function setUnitUi(next) {
    unit = next === 'cm' ? 'cm' : 'in';
    root.querySelectorAll('[data-myd-sc-unit]').forEach((btn) => {
      const on = btn.getAttribute('data-myd-sc-unit') === unit;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function unitLabelKind(text) {
    const t = String(text || '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();
    if (t === 'cm' || t === 'centimetre' || t === 'centimeter' || t === 'centimetres' || t === 'centimeters') {
      return 'cm';
    }
    if (t === 'in' || t === 'inch' || t === 'inches') return 'in';
    return null;
  }

  function kiwiActiveUnit() {
    const scope = host || document;
    const active = scope.querySelector('.ks-unit-toggle-label.kiwi-active, .ks-unit-toggle .kiwi-active');
    if (!active) return null;
    return unitLabelKind(cellText(active));
  }

  function clickKiwiUnit(want) {
    const scope = host || document;
    // Only real unit labels — wrappers contain both "inches" and "cm" and poison matching.
    const labels = scope.querySelectorAll('.ks-unit-toggle-label');
    const wantUnit = want === 'cm' ? 'cm' : 'in';
    let target = null;
    labels.forEach(function (el) {
      if (unitLabelKind(cellText(el)) === wantUnit) target = el;
    });
    if (!target) return false;
    if (target.classList.contains('kiwi-active')) return true;
    try {
      target.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
      target.click();
      return true;
    } catch (e) {
      return false;
    }
  }

  function cacheKeyFor(productId, unitVal) {
    return String(productId || '') + ':' + (unitVal === 'cm' ? 'cm' : 'in') + ':all:v3';
  }

  function convertParsedUnits(parsed, fromUnit, toUnit) {
    if (!parsed || !parsed.body || fromUnit === toUnit) return parsed;
    const from = fromUnit === 'cm' ? 'cm' : 'in';
    const to = toUnit === 'cm' ? 'cm' : 'in';
    if (from === to) return parsed;
    const factor = from === 'in' && to === 'cm' ? 2.54 : 1 / 2.54;
    const body = parsed.body.map(function (row) {
      return row.map(function (cell, idx) {
        if (idx === 0) return cell; // size label
        const raw = String(cell == null ? '' : cell).trim();
        if (!raw) return cell;
        const n = parseFloat(raw.replace(/[^0-9.\-]/g, ''));
        if (!isFinite(n)) return cell;
        const converted = n * factor;
        const rounded =
          to === 'cm' ? Math.round(converted * 10) / 10 : Math.round(converted * 2) / 2;
        return String(rounded);
      });
    });
    return {
      headers: parsed.headers.slice(),
      body: body,
      htm: parsed.htm || null,
      charts: parsed.charts || null,
      activeIndex: parsed.activeIndex,
    };
  }

  function convertChartBundleUnits(bundle, fromUnit, toUnit) {
    if (!bundle) return bundle;
    if (!bundle.charts || !bundle.charts.length) {
      return convertParsedUnits(bundle, fromUnit, toUnit);
    }
    const charts = bundle.charts.map(function (chart) {
      const converted = convertParsedUnits(
        { headers: chart.headers, body: chart.body },
        fromUnit,
        toUnit
      );
      return {
        title: chart.title,
        headers: converted.headers,
        body: converted.body,
      };
    });
    const idx = Math.min(bundle.activeIndex || 0, charts.length - 1);
    return {
      charts: charts,
      activeIndex: idx,
      headers: charts[idx].headers,
      body: charts[idx].body,
      htm: bundle.htm || null,
    };
  }

  function waitForKiwiUnit(want, ms) {
    ms = ms || 900;
    const wantUnit = want === 'cm' ? 'cm' : 'in';
    return new Promise(function (resolve) {
      const start = Date.now();
      const tick = function () {
        if (kiwiActiveUnit() === wantUnit) {
          resolve(true);
          return;
        }
        if (Date.now() - start >= ms) {
          resolve(false);
          return;
        }
        setTimeout(tick, 40);
      };
      tick();
    });
  }

  function productKey(p) {
    return String(p?.id || p?.product || '');
  }

  function toKiwiData(product, forceForeign) {
    const existing = (window.KiwiSizing && window.KiwiSizing.data) || {};
    const p = product || {};
    const explicitId = p.id != null ? p.id : p.product != null ? p.product : null;
    const ctxId = currentPdpContextId();
    const isForeign =
      !!forceForeign ||
      (explicitId != null && ctxId != null && String(explicitId) !== String(ctxId));
    const id = explicitId != null ? explicitId : existing.product;
    const tags = Array.isArray(p.tags) ? p.tags.join(', ') : p.tags;
    // Shopify /products/*.js uses product_type; Liquid/Kiwi use type
    const type = p.type || p.product_type || '';
    const images = Array.isArray(p.images)
      ? p.images.map((img) => (typeof img === 'string' ? img : img?.src)).filter(Boolean)
      : null;
    // product.js options are often ["Size"] strings
    const options = Array.isArray(p.options)
      ? p.options.map(function (o) {
          return typeof o === 'string' ? o : o?.name || o;
        })
      : p.options;
    if (isForeign) {
      return {
        product: id != null ? String(id) : '',
        title: p.title || '',
        vendor: p.vendor || '',
        type: type,
        tags: tags || '',
        options: options || [],
        variants: p.variants || [],
        collections: p.collections || [],
        images: images || [],
      };
    }
    return {
      product: id != null ? String(id) : existing.product,
      title: p.title || existing.title,
      vendor: p.vendor || existing.vendor,
      type: type || existing.type,
      tags: tags || existing.tags,
      options: options || existing.options,
      variants: p.variants || existing.variants,
      collections: p.collections || existing.collections,
      images: images || existing.images,
    };
  }

  function syncMeta(data, replace) {
    try {
      if (window.ShopifyAnalytics?.meta?.product && data.product) {
        window.ShopifyAnalytics.meta.product.id = Number(data.product);
        window.ShopifyAnalytics.meta.product.gid = 'gid://shopify/Product/' + data.product;
        if (data.type) window.ShopifyAnalytics.meta.product.type = data.type;
      }
      if (window.meta?.product && data.product) {
        window.meta.product.id = Number(data.product);
      }
    } catch (e) {}
    window.KiwiSizing = window.KiwiSizing || {};
    if (replace) {
      window.KiwiSizing.data = Object.assign({}, data);
    } else {
      window.KiwiSizing.data = Object.assign({}, window.KiwiSizing.data || {}, data);
    }
  }

  function prefetchPlugin() {
    if (typeof window.ensureKiwiSizingPlugin === 'function') {
      window.ensureKiwiSizingPlugin().catch(function () {});
    }
    if (typeof window.warmupKiwiSizingPlugin === 'function') {
      window.warmupKiwiSizingPlugin();
    }
  }

  function loadIntoHost(product, opts) {
    const seq = ++loadSeq;
    const fromQuickAdd = !!(opts && opts.fromQuickAdd);
    const ctxId = currentPdpContextId();
    const data = toKiwiData(product, fromQuickAdd);
    const targetId = data.product != null ? String(data.product) : '';
    const isForeign =
      fromQuickAdd || !!(targetId && ctxId && targetId !== String(ctxId));

    // Reuse a chart we already successfully parsed for this product + unit
    const cachedKey = cacheKeyFor(targetId, unit);
    if (targetId && chartCache[cachedKey]) {
      return Promise.resolve(chartCache[cachedKey]);
    }

    // Prefetch Kiwi chart names (matched to tables by headers)
    const namesPromise = fetchKiwiSizingNames(Object.assign({}, product || {}, data)).then(
      function (list) {
        if (seq === loadSeq) activeKiwiChartNames = list || [];
        return list || [];
      }
    );

    return new Promise(function (resolve) {
      let settled = false;
      let kiwiSnap = null;

      const finish = function (parsed) {
        if (seq !== loadSeq || settled) return;
        settled = true;
        if (parsed) {
          attachHowToMeasure(parsed, targetId);
          if (targetId) chartCache[cacheKeyFor(targetId, unit)] = parsed;
        }
        if (kiwiSnap) {
          // Restore PDP Kiwi meta and rewarm so PDP Size Chart keeps working
          setTimeout(function () {
            rewarmPdpKiwi(kiwiSnap);
          }, 0);
          kiwiSnap = null;
        }
        resolve(parsed);
      };

      const done = function (table) {
        if (seq !== loadSeq || settled) return;
        adoptTableIntoHost(table);
        const wantUnit = unit === 'cm' ? 'cm' : 'in';
        clickKiwiUnit(wantUnit);
        Promise.all([waitForKiwiUnit(wantUnit, 900), namesPromise]).then(function (results) {
          if (seq !== loadSeq || settled) return;
          const ok = results[0];
          let multi = parseAllChartsFrom(host);
          if (!multi) {
            multi = parseTable(findFirstKiwiTable(host) || table);
          }
          if (!ok && multi && wantUnit === 'cm') {
            multi = convertChartBundleUnits(multi, 'in', 'cm');
          } else if (!ok && multi && wantUnit === 'in') {
            const active = kiwiActiveUnit();
            if (active === 'cm') multi = convertChartBundleUnits(multi, 'cm', 'in');
          }
          if (multi && multi.charts && multi.charts.length > 1) {
            multi.activeIndex = pickActiveChartIndex(multi.charts);
            multi.headers = multi.charts[multi.activeIndex].headers;
            multi.body = multi.charts[multi.activeIndex].body;
          }
          finish(multi);
        });
      };

      const ensure =
        typeof window.ensureKiwiSizingPlugin === 'function'
          ? window.ensureKiwiSizingPlugin()
          : Promise.resolve();

      ensure
        .then(function () {
          if (!host) host = document.getElementById('myd-sc-kiwi-host');
          if (!host) {
            finish(null);
            return;
          }

          // Use a unique inject id so we don't fight page-level #KiwiSizingChart
          let injectEl = host.querySelector('#myd-kiwi-inject');
          if (!injectEl) {
            host.innerHTML = '';
            injectEl = document.createElement('div');
            injectEl.id = 'myd-kiwi-inject';
            injectEl.setAttribute('data-display-mode', '0');
            injectEl.setAttribute('data-layout-type', '2');
            host.appendChild(injectEl);
          }
          if (data.product) injectEl.setAttribute('data-product', String(data.product));
          if (data.title) injectEl.setAttribute('data-product-name', String(data.title));
          if (data.vendor) injectEl.setAttribute('data-vendor', String(data.vendor));
          if (data.type) injectEl.setAttribute('data-type', String(data.type));
          if (data.tags) injectEl.setAttribute('data-tags', String(data.tags));

          // PDP / same product: reuse warmed chart.
          if (!isForeign) {
            const existing = findLiveKiwiTable();
            if (existing && collectRows(existing).length >= 2) {
              done(existing);
              return;
            }
          }

          const runLoad = function () {
            try {
              if (isForeign) {
                kiwiSnap = snapshotKiwiState();
                const before = snapshotPageKiwiTables();
                syncMeta(data, true);
                injectEl.innerHTML = '';
                clearPageKiwiMounts();
                window._ks_sizingLoaded = false;

                // Match combined-listing reload: public loader only (loadSizing is flaky)
                const tryPublic = function (attempt) {
                  try {
                    if (typeof window.loadKiwiSizingChart === 'function') {
                      window._ks_sizingLoaded = false;
                      window.loadKiwiSizingChart({});
                    }
                  } catch (e) {}
                  if (attempt < 3) {
                    setTimeout(function () {
                      if (!settled && seq === loadSeq) tryPublic(attempt + 1);
                    }, 350);
                  }
                };

                try {
                  if (typeof window.ks?.on === 'function') {
                    window.ks.on('sizing_loaded', function () {
                      if (settled || seq !== loadSeq) return;
                      const t = findReloadedKiwiTable(before) || findLiveKiwiTable();
                      if (t && collectRows(t).length >= 2) done(t);
                    });
                  }
                } catch (e0) {}

                tryPublic(0);

                waitForReloadedTable(before, 5000).then(function (t) {
                  if (!settled) done(t);
                });
                return;
              }

              // PDP path — public loader, keep page charts
              syncMeta(data, false);
              if (typeof window.loadKiwiSizingChart === 'function') {
                try {
                  window._ks_sizingLoaded = false;
                  window.loadKiwiSizingChart({});
                } catch (e) {}
              }

              try {
                const trigger = document.querySelector(
                  '.ks-chart-container a, .ks-chart-container button, .kiwi-sizing-chart-button-container a, #kiwi-sizing-chart-button, .ks-chart-modal-link, .ks-chart-modal-button'
                );
                trigger?.click?.();
              } catch (e3) {}

              waitForTable(3200).then(function (t) {
                if (!settled) done(t);
              });
            } catch (e) {
              finish(null);
            }
          };

          setTimeout(runLoad, 0);
        })
        .catch(function () {
          if (kiwiSnap) rewarmPdpKiwi(kiwiSnap);
          finish(null);
        });
    });
  }

  var closeTimer = null;

  function openSheet() {
    if (!ensureDom()) return;
    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }
    root.hidden = false;
    root.classList.add('is-mounted');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('myd-sc-lock');
    document.body.classList.add('myd-sc-lock');
    setTab('chart');
    // Double rAF so the off-screen transform paints before we slide up
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (!root || root.hidden) return;
        root.classList.add('is-open');
      });
    });
  }

  function closeSheet() {
    if (!root) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('myd-sc-lock');
    document.body.classList.remove('myd-sc-lock');
    setBusy(false);
    busyBtn = null;

    var sheet = root.querySelector('[data-myd-sc-sheet]');
    var finished = false;
    function finishClose() {
      if (finished) return;
      finished = true;
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
      if (sheet) sheet.removeEventListener('transitionend', onEnd);
      root.classList.remove('is-mounted');
      root.hidden = true;
    }
    function onEnd(e) {
      if (e.target !== sheet || e.propertyName !== 'transform') return;
      finishClose();
    }
    if (sheet) sheet.addEventListener('transitionend', onEnd);
    closeTimer = setTimeout(finishClose, 480);
  }

  async function open(product, opts) {
    if (!ensureDom()) return;
    captureStablePageProductId();
    if (opts?.button) busyBtn = opts.button;
    activeChartPreference = chartPreferenceFromButton(opts?.button);
    setBusy(true);
    openSheet();
    showLoading();
    setUnitUi(unit);

    const fromQuickAdd = !!(
      opts?.fromQuickAdd ||
      opts?.button?.closest?.('myd-search-quick-add') ||
      getOpenQuickAddProduct()
    );

    // Prefer an explicit product (from QA openSizeChart) over context fallback
    const fromCtx = productFromContext(opts?.button);
    const chosen =
      product && (product.id || product.product || product.handle || product.url)
        ? product
        : fromCtx;
    activeProduct = await ensureActiveProduct(chosen);
    setProductTitle(activeProduct);

    const key = productKey(activeProduct) + ':' + unit + ':' + (activeChartPreference[0] || '');
    const data = await loadIntoHost(activeProduct, { fromQuickAdd: fromQuickAdd });
    lastProductKey = key;
    renderTable(data);
    setBusy(false);
  }

  function setProductTitle(product) {
    if (!ensureDom()) return;
    const el = root.querySelector('[data-myd-sc-product]');
    if (!el) return;
    const title = String(product?.title || '').trim();
    if (!title) {
      el.textContent = '';
      el.hidden = true;
      el.removeAttribute('title');
      return;
    }
    el.textContent = title;
    el.setAttribute('title', title);
    el.hidden = false;
  }

  async function switchUnit(next) {
    if (!ensureDom()) return;
    if (unit === next) return;
    const prev = unit;
    const prevActiveIndex = activeChartBundle?.activeIndex || 0;
    setUnitUi(next);
    showLoading();

    const id = productKey(activeProduct);
    const wantKey = cacheKeyFor(id, unit);
    if (id && chartCache[wantKey]) {
      const cached = chartCache[wantKey];
      if (cached?.charts?.length) {
        cached.activeIndex = Math.min(prevActiveIndex, cached.charts.length - 1);
        cached.headers = cached.charts[cached.activeIndex].headers;
        cached.body = cached.charts[cached.activeIndex].body;
      }
      renderTable(cached);
      clickKiwiUnit(unit);
      return;
    }

    const clicked = clickKiwiUnit(unit);
    if (clicked) {
      const ok = await waitForKiwiUnit(unit, 900);
      let parsed = parseAllChartsFrom(host) || parseTable(findFirstKiwiTable(host));
      if (parsed?.charts?.length) {
        parsed.activeIndex = Math.min(prevActiveIndex, parsed.charts.length - 1);
        parsed.headers = parsed.charts[parsed.activeIndex].headers;
        parsed.body = parsed.charts[parsed.activeIndex].body;
      }
      if (parsed && ok) {
        if (id) chartCache[wantKey] = parsed;
        renderTable(parsed);
        return;
      }
      if (parsed && !ok) {
        const converted = convertChartBundleUnits(parsed, prev, unit);
        if (!converted.htm && id && htmCache[id]) converted.htm = htmCache[id];
        if (id) chartCache[wantKey] = converted;
        renderTable(converted);
        return;
      }
    }

    const fromParsed =
      (id && chartCache[cacheKeyFor(id, prev)]) ||
      activeChartBundle ||
      parseAllChartsFrom(host) ||
      parseTable(findFirstKiwiTable(host));
    if (fromParsed) {
      const converted = convertChartBundleUnits(fromParsed, prev, unit);
      if (converted?.charts?.length) {
        converted.activeIndex = Math.min(prevActiveIndex, converted.charts.length - 1);
        converted.headers = converted.charts[converted.activeIndex].headers;
        converted.body = converted.charts[converted.activeIndex].body;
      }
      if (!converted.htm && id && htmCache[id]) converted.htm = htmCache[id];
      if (id) chartCache[wantKey] = converted;
      renderTable(converted);
      return;
    }

    const data = await loadIntoHost(activeProduct || window.KiwiSizing?.data || {});
    renderTable(data);
  }

  function getOpenQuickAddProduct() {
    const qa =
      document.querySelector('myd-search-quick-add.is-open') ||
      document.querySelector('myd-search-quick-add');
    if (!qa || !qa._currentProduct) return null;
    if (typeof qa.isOpen === 'function' && !qa.isOpen()) return null;
    return qa._currentProduct;
  }

  function productFromContext(btn) {
    // Open Select-your-fit always wins over PDP Kiwi meta
    const openQaProduct = getOpenQuickAddProduct();
    if (openQaProduct) return openQaProduct;

    // Quick-add sheet (button may sit inside the custom element)
    const qa = btn?.closest?.('myd-search-quick-add, [data-myd-qa]');
    if (qa && qa._currentProduct) return qa._currentProduct;

    // Combined listing radios
    const radios = document.querySelector('variant-radios, variant-selects');
    if (radios && radios._clKiwiProduct) return radios._clKiwiProduct;

    // Prefer the page product id — KiwiSizing.data may still hold a YML product
    // after Select-your-fit opened Size Chart.
    let pageId = null;
    try {
      pageId = window.ShopifyAnalytics?.meta?.product?.id || window.meta?.product?.id || null;
    } catch (e) {}

    const data = window.KiwiSizing?.data;
    if (data?.product && (!pageId || String(data.product) === String(pageId))) {
      return {
        id: data.product,
        title: data.title,
        vendor: data.vendor,
        type: data.type,
        tags: data.tags,
        options: data.options,
        variants: data.variants,
        images: data.images,
      };
    }
    if (pageId) return { id: pageId };
    return null;
  }

  function bindUi() {
    if (!ensureDom()) return;

    const overlay = root.querySelector('[data-myd-sc-overlay]');
    const sheet = root.querySelector('[data-myd-sc-sheet]');
    const closeBtn = root.querySelector('[data-myd-sc-close]');

    const onOutside = function (e) {
      if (root.hidden) return;
      // Backdrop / root chrome only — never the sheet contents
      if (e.target === overlay || e.target === root) {
        e.preventDefault();
        e.stopPropagation();
        closeSheet();
      }
    };

    // Click + pointerdown so mobile outside taps always dismiss
    overlay?.addEventListener('click', onOutside);
    overlay?.addEventListener('pointerup', onOutside);
    root.addEventListener('click', onOutside);
    closeBtn?.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      closeSheet();
    });

    // Clicks inside the sheet must not bubble to root/outside handlers
    sheet?.addEventListener('click', function (e) {
      const garmentBtn = e.target.closest?.('[data-myd-sc-garment]');
      if (garmentBtn) {
        e.preventDefault();
        selectGarmentChart(garmentBtn.getAttribute('data-myd-sc-garment'));
      }
      e.stopPropagation();
    });
    sheet?.addEventListener('change', function (e) {
      const sizeInput = e.target.closest?.('[data-myd-sc-size]');
      if (!sizeInput) return;
      e.stopPropagation();
      selectSizeFromChart(sizeInput.getAttribute('data-myd-sc-size'), sizeInput);
    });
    sheet?.addEventListener('pointerup', function (e) {
      e.stopPropagation();
    });

    root.querySelectorAll('[data-myd-sc-tab]').forEach((btn) => {
      btn.addEventListener('click', () => setTab(btn.getAttribute('data-myd-sc-tab')));
    });

    root.querySelectorAll('[data-myd-sc-unit]').forEach((btn) => {
      btn.addEventListener('click', () => switchUnit(btn.getAttribute('data-myd-sc-unit')));
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && root && !root.hidden) {
        e.preventDefault();
        closeSheet();
      }
    });

    // Drag handle / header / top-of-scroll content to dismiss
    if (sheet && window.MYDSheetDrag && typeof window.MYDSheetDrag.bind === 'function') {
      window.MYDSheetDrag.bind(sheet, {
        onClose: closeSheet,
        overlay: overlay,
        handleSelector: '.myd-sc__grabber, .myd-sc__handle',
        headerSelector: '.myd-sc__header',
        scrollSelector: '.myd-sc__panel.is-active, .myd-sc__panel',
      });
    }
  }

  function bindTriggers() {
    document.addEventListener(
      'pointerdown',
      function (e) {
        const btn = e.target.closest && e.target.closest(OPEN_SEL);
        if (btn) prefetchPlugin();
      },
      { capture: true, passive: true }
    );

    document.addEventListener(
      'click',
      function (e) {
        const btn = e.target.closest && e.target.closest(OPEN_SEL);
        if (!btn) return;
        // Let myd-search quick-add call MYDSizeChart.open(currentProduct) itself
        // so we never race with PDP Kiwi meta on capture.
        if (
          btn.matches?.('[data-myd-qa-size-chart], .myd-search-qa__size-chart') ||
          btn.closest?.('myd-search-quick-add')
        ) {
          return;
        }
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
        const product = productFromContext(btn);
        // Defer off click stack
        setTimeout(function () {
          open(product, { button: btn });
        }, 0);
      },
      true
    );
  }

  window.MYDSizeChart = {
    open: function (product, opts) {
      return open(product, opts);
    },
    close: closeSheet,
    prefetch: prefetchPlugin,
  };

  function boot() {
    captureStablePageProductId();
    bindUi();
    bindTriggers();
    // Late capture if Shopify analytics meta isn't ready at parse time
    setTimeout(captureStablePageProductId, 500);
    setTimeout(captureStablePageProductId, 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
